import React, { Component } from "react";
import styles from "./Popup.module.scss";
import Wrapper from "../../hoc/Wrapper/Wrapper";
import { withRouter } from "react-router-dom";
import Button from "../UI/Button/Button";
import copy from "../../assets/copy/copy.json"

var classNames = require("classnames");

class SortByModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showPopup: false,
      selectedOption: this.props.selectedOption || copy.myAvailabilityScreen.membersAvailability.sortByOptions.alpha,
      availabilityType: this.props.selectedAvailabilityType || copy.myAvailabilityScreen.agencyAvailabilityTypes.default,
      firstName: this.props.firstName,
      AtoZ: this.props.AtoZ,
    };
  }

  render() {
    if (this.props.isVisible) {
      document.body.classList.add("popup-mode");
    } else {
      document.body.classList.remove("popup-mode");
    }

    let CloseAlertControls = classNames(
      "tileBg2 " + styles.closeAlertControls,
      this.props.className,
      {
        [styles.visible]: this.props.isVisible,
      },
      styles.viewbyModalClass
    );

    let DarkMask = classNames(styles.darkMask, this.props.className, {
      [styles.visible]: this.props.isVisible,
    });
    const alphabetic = copy.myAvailabilityScreen.membersAvailability.sortByOptions.alpha;
    const enteredAvail = copy.myAvailabilityScreen.membersAvailability.sortByOptions.avail;

    return (
      <Wrapper>
        <div>
          <div className={CloseAlertControls}>
            <div className={styles.content}>
              <div className={styles.spanButtons + " " + styles.headingRow}>
                <span>{"Sort by"}</span>
                <button
                  className="closeAlertControls__btn -close"
                  onClick={this.props.onClose}
                >
                </button>
              </div>
              <form>
                <fieldset className={styles.section + " " + styles.noPadding + " " + styles.noBorder + " " + styles.noMargin}>
                  <div className={styles.listItem + " " + styles.sidePadding + " " + styles.topBorders}>
                    <label htmlFor={alphabetic}>{alphabetic}</label>
                    <input
                      id={alphabetic}
                      value={alphabetic}
                      type="radio"
                      name="sortByOptions"
                      checked={this.state.selectedOption === alphabetic}
                      onChange={(change) => this.setState({ selectedOption: change.target.value })}
                    ></input>
                  </div>
                  <fieldset className={styles.section + " " + styles.noPadding + " " + styles.noBorder}>
                    <div
                      className={styles.listItem + " " + styles.subRow + " " + styles.multiSelectRows}
                    >
                      <input
                        type="radio"
                        id="firstName"
                        key="firstName"
                        name="firstNameLastName"
                        disabled={this.state.selectedOption !== alphabetic}
                        checked={this.state.firstName}
                        onChange={() => this.setState({ firstName: !this.state.firstName })}
                      >
                      </input>
                      <label
                        htmlFor="firstName"
                      >First name</label>

                      <input
                        type="radio"
                        id="lastName"
                        key="lastName"
                        name="firstNameLastName"
                        disabled={this.state.selectedOption !== alphabetic}
                        checked={!this.state.firstName}
                        onChange={() => this.setState({ firstName: !this.state.firstName })}

                      >
                      </input>
                      <label
                        htmlFor="lastName"
                      >Last name</label>

                    </div>
                  </fieldset>

                  <fieldset className={styles.section + " " + styles.noPadding + " " + styles.noBorder}>
                    <div
                      className={styles.listItem + " " + styles.subRow + " " + styles.multiSelectRows}
                    >
                      <input
                        type="radio"
                        id="AtoZ"
                        key="AtoZ"
                        name="alphabeticOrder"
                        disabled={this.state.selectedOption !== alphabetic}
                        checked={this.state.AtoZ}
                        onChange={() => this.setState({ AtoZ: !this.state.AtoZ })}

                      >
                      </input>
                      <label
                        htmlFor="AtoZ"
                      >A to Z</label>
                      <input
                        type="radio"
                        id="ZtoA"
                        key="ZtoA"
                        name="alphabeticOrder"
                        disabled={this.state.selectedOption !== alphabetic}
                        checked={!this.state.AtoZ}
                        onChange={() => this.setState({ AtoZ: !this.state.AtoZ })}

                      >
                      </input>
                      <label
                        htmlFor="ZtoA"
                      >Z to A</label>

                    </div>
                  </fieldset>
                  <div
                    className={styles.listItem + " " + styles.sidePadding + " " + styles.topBorders}
                  >
                    <label htmlFor={enteredAvail}>{enteredAvail}</label>
                    <input
                      type="radio"
                      name="sortByOptions"
                      id={enteredAvail}
                      value={enteredAvail}
                      checked={this.state.selectedOption === enteredAvail}
                      onChange={(change) => this.setState({ selectedOption: change.target.value })}
                    ></input>
                  </div>
                  <fieldset className={styles.section + " " + styles.noPadding + " " + styles.noBorder + " " + styles.noMargin}>
                    <div>
                      {this.props.availabilityTypes.map((e, index) => {
                        return (<div key={index} className={styles.listItem + " " + styles.multiSelectRows + " " + styles.subRow}>
                          <label htmlFor={e}>{e}</label>
                          <input
                            type="radio"
                            name="availabilityType"
                            id={e}
                            value={e}
                            disabled={this.state.selectedOption !== enteredAvail}
                            checked={this.state.availabilityType === e}
                            onChange={(change) => this.setState({ availabilityType: change.target.value })}
                          ></input>
                        </div>)
                      })}
                    </div>
                  </fieldset>
                </fieldset>
              </form>
              <ul>
              </ul>
              <div className={styles.bottomButtonContainer}>
                <Button
                  label="Back"
                  buttonClick={this.props.backButton}
                  content="Back"
                  variant="btn_secondary"
                  styles="footerButton"
                ></Button>
                <Button
                  label="Apply"
                  buttonClick={() => this.props.applyButton(this.state.selectedOption, this.state.availabilityType, this.state.firstName, this.state.AtoZ)}
                  content="Apply"
                  variant="btn_secondary"
                  styles="footerButton saveBtnStyle"
                ></Button>
              </div>
            </div>
          </div>
          <div className={DarkMask} />
        </div>
      </Wrapper>
    );
  }
}

export default withRouter(SortByModal);
